import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Restores scroll position on navigation.
 *
 * React Router does not scroll for you: without this, following a `/#forfaits`
 * link from another page left the viewport wherever it was, and every route
 * change kept the previous scroll offset.
 */
export default function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one frame so the target section exists before scrolling to it.
      const target = document.getElementById(hash.slice(1));
      if (target) {
        const frame = requestAnimationFrame(() =>
          target.scrollIntoView({ behavior: 'smooth', block: 'start' }),
        );
        return () => cancelAnimationFrame(frame);
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
